/**
 * Extend the RegExp with a escape functionality.
 *
 * Escape special characters to allow it as input without breaking
 * any regexp that could be applied to the input value.
 *
 * Source: https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript?answertab=votes#tab-top
 */
RegExp.escape = s => s.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
